import * as React from 'react'
import styles from './TimFerrisSection.module.scss'
import ImageBackground from 'components/ImageBackground'
import { ScreenBreakPoint } from 'constants/index'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import cx from 'classnames'

const bg_set = [
	{
		url: 'https://eightsleep.imgix.net/tim-ferris-mobile.png?v=1610724039',
		breakpoint: '0px',
		x: 750, // width of image
		y: 1200, // height of image
	},
	{
		url: 'https://eightsleep.imgix.net/tim-ferris-fotter.png?v=1610724039',
		breakpoint: ScreenBreakPoint.sm + 'px',
		x: 750, // width of image
		y: 400, // height of image
	},
	{
		url: 'https://eightsleep.imgix.net/tim-ferris-fotter.png?v=1610724039',
		breakpoint: ScreenBreakPoint.md + 'px',
		x: 1800,
		y: 700,
	},
]

const TimFerrissSection: React.SFC<any> = () => {
	return (
		<>
			<ImageBackground
				bgSet={bg_set}
				className="home-hero-bg-img"
			>
				<div className={styles.tim_ferriss_container}>
					<h1 className={styles.tim_ferriss_title}>Tim Ferriss Approved</h1>
					<p className={styles.tim_ferriss_description}>
						Renowned NYT & WSJ best-selling author, entrepreneur, and podcaster Tim Ferriss swears by the Pod Pro Cover to solve his sleep temperature issues. Learn more for yourself.
					</p>
					{/* <p className={styles.tim_ferriss_description_second}>- Tim Ferriss</p> */}
					<AnchorLink
						offset="115"
						href="#main_shop"
						className={cx(styles.tim_ferriss_button, 'btn-lnk')}
						aria-label={'Discover the app'}
					>
						Get the cover
					</AnchorLink>
				</div>
			</ImageBackground>
		</>
	)
}

export default TimFerrissSection
